import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './public/Login/Login';
import Settings from './private/Settings/Settings';
import Dashboard from './private/Dashboard/Dashboard';
import Users from './private/Users/Users';
import Centrodecustos from './private/Centrodecustos/Centrodecustos';
import Unidades from './private/Unidades/Unidades';
import ContasAPagars from './private/Contasapagar/Contasapagar';
import Produtos from './private/Produtos/Produtos';
import LojaList from './private/Loja/Loja';
import Carrinho from './private/Loja/Carrinho';
import Carrinho2 from './private/Loja/Carrinho2';
import Checkout from './private/Loja/Checkout';
import Filiados from './private/Filiados/Filiados';
import EditFiliado from './private/Filiados/EditFiliado';
import Pedidos from './private/Pedidos/Pedidos';


function Rotas() {


    const PrivateRoute = ({ children }) => {
        const authed = localStorage.getItem('token') !== null; //  returns true or false based on localStorage

        return authed ? children : <Navigate to="/" />;
    }

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/dashboard" element={<PrivateRoute>  <Dashboard /> </PrivateRoute>} />
                <Route path="/settings" element={<PrivateRoute>  <Settings /> </PrivateRoute>} />
                <Route path="/users" element={<PrivateRoute>  <Users /> </PrivateRoute>} />
                <Route path="/filiados" element={<PrivateRoute>  <Filiados /> </PrivateRoute>} />
                <Route path="/filiado/:id?" element={<PrivateRoute>  <EditFiliado /> </PrivateRoute>} />
                <Route path="/centrodecustos" element={<PrivateRoute>  <Centrodecustos /> </PrivateRoute>} />
                <Route path="/unidades" element={<PrivateRoute>  <Unidades /> </PrivateRoute>} />
                <Route path="/pedidos" element={<PrivateRoute>  <Pedidos /> </PrivateRoute>} />
                <Route path="/contasapagar" element={<PrivateRoute>  <ContasAPagars /> </PrivateRoute>} />
                <Route path="/produtos" element={<PrivateRoute>  <Produtos /> </PrivateRoute>} />
                <Route path="/loja" element={<PrivateRoute>  <LojaList /> </PrivateRoute>} />
                <Route path="/carrinho" element={<PrivateRoute>  <Carrinho /> </PrivateRoute>} />
                <Route path="/carrinho2" element={<PrivateRoute>  <Carrinho2 /> </PrivateRoute>} />
                <Route path="/checkout" element={<PrivateRoute>  <Checkout /> </PrivateRoute>} />

            </Routes>
        </BrowserRouter>
    )
}

export default Rotas;